(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-buybox"] && !Shopify.designMode) return;
  try {
    
(function(){
  function money(c){var v=c/100;return '$'+(v%1?v.toFixed(2):String(v))}
  function addBiz(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n--}return d}
  function fmt(d){return d.toLocaleDateString('en-US',{month:'short',day:'numeric'})}
  var calm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root){
    if(!root||root.dataset.mlReady)return;root.dataset.mlReady='1';
    var V=JSON.parse(root.querySelector('[data-ml-variants]').textContent);
    var q=function(s){return root.querySelector(s)};
    var tiers=[].slice.call(root.querySelectorAll('.ml-tier'));
    var base=V[0]?V[0].price:0;
    function wasOf(b,v){var u=+b.dataset.units||+b.dataset.q;var w=Math.max(base*u,v.compare||0);return w>v.price?w:0}
    tiers.forEach(function(b){var n=+b.dataset.q,u=+b.dataset.units||n,v=V[n-1];if(!v||u<2)return;var was=wasOf(b,v);if(!was)return;b.querySelector('[data-ml-tunit]').textContent=money(Math.round(v.price/u))+' per stick';b.querySelector('[data-ml-twas]').textContent=money(was);b.querySelector('[data-ml-tsave]').textContent='Save '+money(was-v.price)});
    function cur(){var b=tiers.filter(function(x){return x.getAttribute('aria-checked')==='true'})[0]||tiers[0];return {b:b,v:V[(+b.dataset.q)-1]}}
    function update(){var c=cur();if(!c.v)return;var w=wasOf(c.b,c.v);q('[data-ml-total]').textContent=money(c.v.price);q('[data-ml-totwas]').textContent=w?money(w):'';q('[data-ml-stprice]').textContent=money(c.v.price);q('[data-ml-stsub]').textContent=c.v.pack+' · 90-day money-back';q('[data-ml-atc]').disabled=!c.v.available}
    tiers.forEach(function(b){b.addEventListener('click',function(){tiers.forEach(function(x){x.setAttribute('aria-checked',x===b)});update()})});
    root.querySelector('[data-ml-tiers]').addEventListener('keydown',function(e){var k=e.key,i=tiers.indexOf(document.activeElement);if(i<0||['ArrowDown','ArrowRight','ArrowUp','ArrowLeft'].indexOf(k)<0)return;e.preventDefault();var n=tiers[(i+(k==='ArrowDown'||k==='ArrowRight'?1:tiers.length-1))%tiers.length];n.focus();n.click()});
    document.addEventListener('ml:pick',function(e){var t=tiers[(e.detail||3)-1];if(t)t.click();root.scrollIntoView({behavior:calm?'auto':'smooth'})});
    var eta=q('[data-ml-eta]');if(eta){var a=addBiz(new Date(),+root.dataset.etaMin),z=addBiz(new Date(),+root.dataset.etaMax);eta.textContent=fmt(a)+' - '+fmt(z)}
    var main=q('[data-ml-gal]'),th=[].slice.call(root.querySelectorAll('[data-ml-thumbs] button')),gi=q('[data-ml-gidx]');
    th.forEach(function(b,i){b.addEventListener('click',function(){main.scrollTo({left:main.clientWidth*i,behavior:calm?'auto':'smooth'})})});
    main.addEventListener('scroll',function(){var i=Math.round(main.scrollLeft/main.clientWidth);th.forEach(function(b,j){b.setAttribute('aria-current',i===j)});if(gi)gi.textContent=i+1},{passive:true});
    function add(btn){
      var c=cur();if(!c.v||!c.v.available)return;var err=q('[data-ml-err]');err.hidden=true;btn.disabled=true;
      var root_url=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/');
      fetch(root_url+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:c.v.id,quantity:1}]})})
        .then(function(r){return r.json()}).then(function(res){
          btn.disabled=false;
          if(res.status){err.textContent=res.description||res.message||'Could not add to cart.';err.hidden=false;return}
          var drawer=document.querySelector('cart-drawer-component');
          document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:res,sourceId:root.id,data:{source:'ml-buybox',itemCount:1}}}));
          if(drawer&&typeof drawer.open==='function'){drawer.open()}else{window.location.href=root_url+'cart'}
        }).catch(function(){btn.disabled=false;err.textContent='Connection problem, please try again.';err.hidden=false});
    }
    q('[data-ml-atc]').addEventListener('click',function(){add(this)});
    var stk=q('[data-ml-sticky]'),stb=q('[data-ml-stbtn]'),atc=q('[data-ml-atc]'),tick=false;
    stb.addEventListener('click',function(){add(atc)});
    // La barre n'apparaît qu'une fois le bloc d'achat dépassé ET la page bien entamée
    // (sinon elle s'affiche dès les premiers pixels de scroll, juste sous l'offre).
    function chk(){tick=false;var r=atc.getBoundingClientRect(),past=r.bottom<0||r.top>window.innerHeight,deep=window.scrollY>window.innerHeight*1.25,on=past&&deep;if(on!==stk.classList.contains('is-on')){stk.classList.toggle('is-on',on);stk.setAttribute('aria-hidden',!on);stb.tabIndex=on?0:-1}}
    window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(chk)}},{passive:true});chk();
    update();
  }
  function boot(){document.querySelectorAll('[data-ml-buybox]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-cart-upsell"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* ---------- 1. TIROIR PANIER ---------- */
  var cfgEl=document.querySelector('[data-ml-cart-cfg]'),tpl=document.querySelector('[data-ml-cart-tpl]');
  if(cfgEl&&tpl){
    var cfg=JSON.parse(cfgEl.textContent),root=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/'),busy=false,upLine=null,cart=null;
    var fsPending=cfg.fsPending||'You are [left] away from FREE US shipping.';
    var fsDone=cfg.fsDone||'You have unlocked FREE US shipping.';
    var money=function(c){try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(c/100)}catch(e){return '$'+(c/100).toFixed(2)}};
    var targets=function(){
      var t=[],seen=[];
      document.querySelectorAll('cart-drawer-component, .cart-drawer, dialog[open], main cart-items-component, main .cart-items').forEach(function(host){
        var di=host.querySelector('cart-items-component, .cart-items, [class*="cart-items"]')||host;
        if(di&&seen.indexOf(di)<0){seen.push(di);t.push(di)}
      });
      return t;
    };
    var clear=function(){document.querySelectorAll('[data-ml-cart]').forEach(function(n){n.remove()})};
    var render=function(){
      if(!cart||cart.item_count===0){clear();return}
      targets().forEach(function(host){
        if(host.querySelector('[data-ml-cart]'))return;
        var n=tpl.content.firstElementChild.cloneNode(true);
        var prog=n.querySelector('[data-ml-cart-prog]'),bar=n.querySelector('[data-ml-cart-bar]'),txt=n.querySelector('[data-ml-cart-prog-txt]'),total=cart.total_price;
        var pct=Math.max(0,Math.min(100,total/cfg.threshold*100));bar.style.width=pct+'%';
        if(total>=cfg.threshold){prog.classList.add('is-done');txt.innerHTML=fsDone}
        else{txt.innerHTML=fsPending.replace('[left]','<b>'+money(cfg.threshold-total)+'</b>')}
        var up=n.querySelector('[data-ml-cart-up]');
        if(cfg.v1&&cfg.v2&&upLine){up.hidden=false;var dEl=n.querySelector('[data-ml-cart-diff]');if(dEl)dEl.textContent='+'+cfg.diff;n.querySelector('[data-ml-cart-btn]').addEventListener('click',upgrade)}else{up.hidden=true}
        host.insertBefore(n,host.firstChild);
      });
    };
    var check=function(){
      return fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){
        cart=c;
        if(cfg.v1&&cfg.v2){var ones=c.items.filter(function(i){return i.variant_id===cfg.v1}),twos=c.items.filter(function(i){return i.variant_id===cfg.v2});upLine=(ones.length===1&&ones[0].quantity===1&&!twos.length)?ones[0]:null}
        clear();render();return c;
      }).catch(function(){});
    };
    var upgrade=function(e){
      if(busy||!upLine)return;busy=true;e.currentTarget.disabled=true;
      fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:upLine.key,quantity:0})})
        .then(function(){return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:cfg.v2,quantity:1}]})})})
        .then(function(){window.location.reload()})
        .catch(function(){window.location.reload()});
    };
    document.addEventListener('cart:update',function(e){if(!e.detail||e.detail.sourceId!=='ml-cart-upsell')setTimeout(check,250)});
    var tmr=null;
    new MutationObserver(function(){if(!cart||cart.item_count===0)return;clearTimeout(tmr);tmr=setTimeout(render,80)}).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('click',function(e){
      var t=e.target.closest&&e.target.closest('[href*="/cart"], [aria-label*="art"], [class*="cart-icon"], .header-actions__action');
      if(t)setTimeout(check,400);
    },true);
    check();
  }

  /* ---------- 2. CORRECTIF GALERIE : clic sur les vignettes ---------- */
  document.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-ml-thumbs] button');
    if(!btn)return;
    var wrap=btn.closest('[data-ml-thumbs]');
    var gal=wrap&&wrap.parentElement?wrap.parentElement.querySelector('[data-ml-gal]'):null;
    if(!gal)gal=document.querySelector('[data-ml-gal]');
    if(!gal)return;
    var i=[].indexOf.call(wrap.querySelectorAll('button'),btn);
    if(i<0)return;
    var calm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    gal.scrollTo({left:gal.clientWidth*i,behavior:calm?'auto':'smooth'});
    wrap.querySelectorAll('button').forEach(function(b,j){b.setAttribute('aria-current',j===i)});
    var gi=document.querySelector('[data-ml-gidx]');
    if(gi)gi.textContent=i+1;
  },false);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-final"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){var a=e.target.closest('[data-ml-pick]');if(!a||!document.querySelector('[data-ml-buybox]'))return;e.preventDefault();document.dispatchEvent(new CustomEvent('ml:pick',{detail:+a.dataset.mlPick||3}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-menu-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tpl = document.querySelector('[data-ml-menutrust-tpl]');
  if (!tpl) return;
  function panel() {
    var wrap = document.querySelector('.header__drawer');
    if (!wrap) return null;
    var det = wrap.querySelector('details');
    if (det) {
      var kid = Array.prototype.find.call(det.children, function (c) { return c.tagName !== 'SUMMARY'; });
      if (kid) return kid;
    }
    var list = wrap.querySelector('ul');
    return list ? list.parentElement : null;
  }
  function inject() {
    var host = panel();
    if (!host || host.querySelector('.ml-mt')) return;
    host.appendChild(tpl.content.firstElementChild.cloneNode(true));
  }
  function boot() {
    inject();
    var wrap = document.querySelector('.header__drawer');
    if (!wrap) return;
    new MutationObserver(inject).observe(wrap, { childList: true, subtree: true });
    wrap.addEventListener('toggle', inject, true);
    wrap.addEventListener('click', function () { setTimeout(inject, 60); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
